import { Storage } from '@/enums/storage.enum';
import { TableName } from '@/enums/tableName';
import { tryParseInt } from '@/utils/number';

/**
 * Pobiera identyfikator profilu z sesji
 *
 * @export
 * @returns
 */
export function getProfileId() {
  return tryParseInt(localStorage.getItem(Storage.PROFILE_ID) as string);
}

/**
 * Zwraca ciąg uprawnienia do załadowania danych poprzedniego wniskodawcy
 *
 * @export
 * @returns
 */
export function loadPreviousApplicantPermission() {
  return `DOCUMENT.SET_PREVIOUS_DATA:${TableName.profile}:${getProfileId()}`;
}
